/** Номер лида: ссылка на карточку `/leads/<id>` и рядом — лид в Bitrix. */
import { ExternalLink } from "lucide-react";
import { Link } from "react-router";

import { leadUrl } from "@/lib/leadQueue";

export function LeadLink({ id, className = "" }: { id: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap ${className}`}>
      <Link to={`/leads/${id}`} className="font-mono underline" title="карточка лида">
        {id}
      </Link>
      <a href={leadUrl(id)} target="_blank" rel="noreferrer noopener" className="text-fg-faint hover:text-accent" title="лид в Bitrix">
        <ExternalLink size={11} aria-hidden />
        <span className="sr-only">лид {id} в Bitrix</span>
      </a>
    </span>
  );
}
